import { type ReactNode } from 'react'
import {
	Callout as BaseCallout,
	type CalloutType,
} from '#app/components/ui/callout.tsx'

export function Callout({
	type = 'info',
	children,
}: {
	type?: CalloutType
	children: ReactNode
}) {
	return (
		<BaseCallout type={type} className="not-prose my-6">
			{children}
		</BaseCallout>
	)
}
